import homepageJson from '../content/homepage.json';

/**
 * Editable homepage copy.
 *
 * The content lives in src/content/homepage.json, which Sveltia CMS writes to
 * (see public/admin/config.yml and docs/CMS.md). Everything here is copy only -
 * layout, styling and section order stay in the components.
 *
 * @typedef {Object} HomepageHero
 * @property {string} title - Main hero headline
 * @property {string} subtitle - Optional line under the headline; hidden when empty
 *
 * @typedef {Object} ApproachColumn
 * @property {string} heading - Column heading
 * @property {string[]} paragraphs - Body paragraphs, rendered in order
 *
 * @typedef {Object} HomepageSections
 * @property {{ heading: string }} services - Solutions & Services header
 * @property {{ headingWords: string[], intro: string, description: string }} updates - Updates section header, intro and description
 * @property {{ heading: string, columns: ApproachColumn[] }} approach - Our Approach header and two-column copy
 */

/** @type {HomepageHero} */
export const hero = homepageJson.hero;

/** @type {HomepageSections} */
export const sections = homepageJson.sections;

/**
 * The four RSMC pillars. Re-exported through src/constants/rsmcPillars.js so
 * existing imports keep working.
 */
export const pillars = homepageJson.pillars;

export default homepageJson;
